import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getIsOffline } from '../../store/selectors';

function Offline({ isOffline, children }) {
  return (
    <>
      {isOffline && children}
    </>
  );
}
Offline.propTypes = {
  isOffline: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isOffline: getIsOffline(state),
});
export default connect(
  mapStateToProps,
  {},
)(Offline);
